import React from 'react';
import { __ } from 'i18n/index';
import TextWithElements from 'react/elements/TextWithElements';
import { formatLadderTime } from 'react/elements/LadderTime';
import { Dashboard } from 'components/Dashboard.jsx';
import { ChatMessageNotification } from 'models/ChatMessage.jsx';
import { privateChatMessageHolder } from 'components/PrivateChatMessageHolder.jsx';
import { Settings } from 'components/Settings.jsx';
import { FloatingHostCode } from 'react/chat/inner/display_pieces/messages/notifications/FloatingHostCode.jsx';
import { ChatNotificationHostCodeComponent } from 'react/chat/inner/display_pieces/messages/notifications/ChatNotificationHostCodeComponent.jsx';
import { UserComponent } from 'react/UserComponent.jsx';
import RpgChatNotificationMessage from './RpgChatNotificationMessage';
import ChatNotificationMatchMessage from './ChatNotificationMatchMessage';
import { CharacterComponent } from "../../../../../CharacterComponent";
import { StageComponent } from "../../../../../StageComponent";
import MatchReportTypeText from "../../../../../match/MatchReportTypeText";
import { TeamComponent } from "../../../../../match/active/TeamComponent";
import { TimeHolderComponent } from "../TimeHolderComponent";

class ChatNotificationReportComponent extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			testState: null
		};
	}

	render() {
		const { chatMessage } = this.props;
		switch(chatMessage.type) {
			case ChatMessageNotification.types.FRIEND_REQUEST:
				return (
					<div className='chat_message chat_notification'>
						<UserComponent user={chatMessage.player} /> wants to be friends!
					</div>
				);
			case ChatMessageNotification.types.FRIEND_REQUEST_ACCEPTED:
				return (
					<div className='chat_message chat_notification'>
						<UserComponent user={chatMessage.player} /> accepted your friend request!
					</div>
				);
			case ChatMessageNotification.types.DATE_CHANGE:
				return this.renderDateChange();
			case ChatMessageNotification.types.MOD_NOTIFICATION:
				return this.renderModNotification();
			case ChatMessageNotification.types.CHAT_RESTRICTION:
				return this.renderChatRestriction();
			case ChatMessageNotification.types.DIRECT_MESSAGE:
				return this.renderDirectMessage();
			case ChatMessageNotification.types.MATCH_MESSAGE:
				return (
					<ChatNotificationMatchMessage
						chatMessage={chatMessage}
					/>
				);
			case ChatMessageNotification.types.TEXT:
				return this.renderText();
			case ChatMessageNotification.types.MULTIPLE_REPORTS:
				return this.renderMultipleReports();
			case ChatMessageNotification.types.HOST_CODE:
				return this.renderHostCode();
			case ChatMessageNotification.types.JOINED_MATCH: {
				return (
					<div className='chat_message chat_notification'>
						<TextWithElements text={__('%s has joined the match.')} elements={[<UserComponent key='player' user={chatMessage.player} />]} />
					</div>
				);
			}
			case ChatMessageNotification.types.ACCEPTED_INTO_MATCH: {
				return (
					<div className='chat_message chat_notification'>
						<TextWithElements text={__('%s was confirmed by the host!')} elements={[<UserComponent key='player' user={chatMessage.player} />]} />
					</div>
				);
			}
			case ChatMessageNotification.types.INVITE_PLAYER_NO_EXIST:
				return (
					<div className='chat_message chat_notification'>
						<UserComponent user={chatMessage.player} /> does not exist...
					</div>
				);
			case ChatMessageNotification.types.INVITE_NO_PERMISSION:
				return (
					<div className='chat_message chat_notification'>
						You do not have permission to invite <UserComponent user={chatMessage.player} /> to
						this chat.
					</div>
				);
			case ChatMessageNotification.types.INVITE_ALREADY_INVITED:
				return (
					<div className='chat_message chat_notification'>
						<UserComponent user={chatMessage.player} /> is already invited.
					</div>
				);
			case ChatMessageNotification.types.INVITE_IN_THERE:
				return (
					<div className='chat_message chat_notification'>
						<UserComponent user={chatMessage.player} /> has already joined this chat.
					</div>
				);
			case ChatMessageNotification.types.RPG_MESSAGE:
				return (
					<div className='chat_message chat_notification rpg_message'>
						<RpgChatNotificationMessage
							chatMessage={chatMessage}
						/>
					</div>
				);
			case ChatMessageNotification.types.SELECT_STAGE:
				return (
					<div className='chat_message'>
						{JSON.stringify(chatMessage)}
					</div>
				);
			case ChatMessageNotification.types.SELECT_CHARACTER:
				return (
					<div className='chat_message'>
						<div>
							<TimeHolderComponent
								time={formatLadderTime(chatMessage.time, 'clockWithSeconds')}
								title={formatLadderTime(chatMessage.time, 'full')}
							/>
							<UserComponent user={Users.retrieveById(chatMessage.player_id)} />{' '}
							selected{' '}
							<CharacterComponent character={chatMessage.character} />
						</div>
					</div>
				);
			case ChatMessageNotification.types.STAGE_STRIKE:
				return (
					<div className='chat_message'>
						<div>
							<TimeHolderComponent
								time={formatLadderTime(chatMessage.time, 'clockWithSeconds')}
								title={formatLadderTime(chatMessage.time, 'full')}
							/>
							<UserComponent user={Users.retrieveById(chatMessage.player_id)} />{' '}
							struck{' '}
							<StageComponent stage={chatMessage.stage} />
						</div>
					</div>
				);
			case ChatMessageNotification.types.SUBMIT_RESULT:
				console.log('what is this', chatMessage);
				return (
					<div className='chat_message'>
						<div>
							<TimeHolderComponent
								time={formatLadderTime(chatMessage.time, 'clockWithSeconds')}
								title={formatLadderTime(chatMessage.time, 'full')}
							/>
							<TeamComponent
								team={chatMessage.match.getTeam(chatMessage.team_number)}
								displayPlayers={true}
							/>
							{' '}submitted{' '}
							<MatchReportTypeText
								report={chatMessage.result}
							/>
						</div>
					</div>
				);
			case ChatMessageNotification.types.GAME_START:
				return (
					<div className='chat_message game_start'>
						<div>
							<TimeHolderComponent
								time={formatLadderTime(chatMessage.time, 'clockWithSeconds')}
								title={formatLadderTime(chatMessage.time, 'full')}
							/>
							Game <span className='emphasized_bright'>{chatMessage.game_number}</span>
						</div>
					</div>
				);
		}

		// SELECT_CHARACTER:'SELECT_CHARACTER',
		// 	SELECT_STAGE: 'SELECT_STAGE',
		// 	STAGE_STRIKE: 'STAGE_STRIKE',
		// 	SUBMIT_RESULT: 'SUBMIT_RESULT',
		// 	GAME_START: 'GAME_START',
		throw new Error('We need to come back to this type : ' + chatMessage.type);
	}

	renderDateChange() {
		const date = this.props.chatMessage.date;
		return (
			<div className='chat_message chat_notification date_change_notification'>
				<span className='user_things'>
					<span className='message_things'>
						<span className='message'><span className='chat_notification_message'>{formatLadderTime(date, 'date')}</span></span>
					</span>
				</span>
			</div>
		);
	}

	renderMultipleReports() {
		return (
			<div className='chat_message chat_notification chat_restricted_notification'>
				<UserComponent user={this.props.chatMessage.player} /> has multiple
				warnings for negative behavior, disputes will be cancelled.
			</div>
		);
	}

	renderText() {
		return (
			<div className='chat_message chat_notification'>
				{this.props.chatMessage.summary}
			</div>
		);
	}

	renderModNotification() {
		//Possibly limit summary to 70 characters
		const notification = this.props.chatMessage;
		let summary = notification.summary;
		const maxLength = 70;
		summary = summary.length > maxLength ? summary.substring(0, maxLength) + '...' : summary;

		return (
			<div className='chat_message chat_notification'>
				<a
					href={notification.url}
					target='_blank'
				>
					<UserComponent user={notification.player} />
					<span
						className='chat_notification_title'>{notification.title}</span> -
					<span title={notification.summary} className='description_summary'>{summary}</span>
				</a>
			</div>
		);
	}

	renderDirectMessage() {
		const notification = this.props.chatMessage;

		const openPrivateChat = () => {
			privateChatMessageHolder.openPrivateChat(notification.player);
		};

		return (
			<div className='chat_message chat_notification direct_chat_notification'>
				<span className='clickable' onClick={openPrivateChat}>Direct Chat From </span>
				<UserComponent user={notification.player} />
				<span className='clickable' onClick={openPrivateChat}>{' ' + notification.summary}</span>
			</div>
		);
	}

	renderHostCode() {
		const { chatMessage } = this.props;
		const myPlayer = chatMessage.myPlayer;
		const match = chatMessage.match;

		const shouldFloat = match && match.usesDolphinHostCodes();
		if(myPlayer && shouldFloat && Settings.isChecked('host_code_clipboard_helper')) {
			return (
				<FloatingHostCode
					{...this.props} />
			);
		}
		else {
			return <ChatNotificationHostCodeComponent {...this.props} />;
		}
	}

	renderChatRestriction() {
		return (
			<div onClick={this.chatRestrictionClick.bind(this)}
			     className='chat_message chat_notification chat_restricted_notification'>
				{this.props.chatMessage.player.isMe() &&
				<span>You are chat restricted</span>
				}
				{!this.props.chatMessage.player.isMe() &&
				<span>
						<UserComponent user={this.props.chatMessage.player} />
					&nbsp;is chat restricted and can only use predefined messages (Click to remove)
					</span>
				}
			</div>
		);
	}

	chatRestrictionClick() {
		if(this.props.chatMessage.player.isMe()) {
			return;
		}
		const chatMessage = this.props.chatMessage;
		const match = chatMessage.match;
		Dashboard.ladderPopup('Enable match chat restricted players to chat?', 'Disable Match Chat Restriction?',
			{
				buttons: [
					{
						text: 'No',
						dismiss: true
					},
					{
						text: 'Yes',
						dismiss: true,
						click: (popup) => {
							$.post(siteUrl + '/matchmaking/end-chat-restriction', { match_id: match.id }, function(response) {
								if(response.success) {
									chatMessage.summary = 'Chat Restriction Removed';
								}
								else if(response.error) {
									match.postNotification(response.error);
								}
							});
						}
					}
				]
			});
	}
}

export { ChatNotificationReportComponent };